import derbywardLogo from "../../public/images/logos/derbywars-logo-color.svg";
import equibaseLogo from "../../public/images/powered-by-equibase.gif";
import { Link } from "react-router-dom";
import React from "react";
import If from "./if";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="l-footer">
      <div className="l-wrapper l-wrapper--supersize">
        <div className="l-content">
          <If condition={window.env.isAffiliate}>
            <ul className="footer-list">
              <li className="footer-list_item">
                <span className="text--is-italic display--is-inline-block margin-bottom--is-5 vertical-align--is-bottom">
                  Powered by
                </span>

                <a href="https://derbywars.com" rel="noreferrer" target="_blank">
                  <img className="vertical-align--is-bottom" height="45" src={derbywardLogo} />
                </a>
              </li>
            </ul>
          </If>

          <ul className="footer-list">
            <li className="footer-list_item">
              &copy;
              {new Date().getFullYear()}

              {" "}

              {window.env.corporationName}
            </li>
          </ul>

          <ul className="footer-list footer-list--links">
            <li className="footer-list_item">
              <a href="http://blog.derbywars.com/about-us/">
                About Us
              </a>
            </li>

            <li className="footer-list_item">
              <a href="http://blog.derbywars.com/contact-us/">
                Contact Us
              </a>
            </li>

            <li className="footer-list_item">
              <a href="https://horse-racing-labs-llc.helpcenter.guide/collections/derby-wars-fa-qs-9fa140-8e114" rel="noreferrer" target="_blank">
                FAQ
              </a>
            </li>

            <li className="footer-list_item">
              <Link to="/privacy-policy/">
                Privacy Policy
              </Link>
            </li>

            <li className="footer-list_item">
              <a href="http://blog.derbywars.com/official-rules-1/">
                Rules
              </a>
            </li>

            <li className="footer-list_item">
              <Link to="/terms-and-conditions">
                Terms &amp; Conditions
              </Link>
            </li>

            <li className="footer-list_item">
              <a href={`https://www.horseracingnation.com/p/c/Kentucky_Derby_${currentYear}_Contenders`} rel="noopener noreferrer" target="_blank">
                {`Kentucky Derby ${currentYear}`}
              </a>
            </li>
          </ul>

          <div className="batch-g batch-g--gutter batch-g--padding footer-list--links">
            <div className="batch-c-1-1 batch-c-md-1-8 batch-c-lg-1-8">
              <img alt="Powered by Equibase" src={equibaseLogo} />
            </div>

            <div className="batch-c-1-1 batch-c-md-7-8 batch-c-lg-7-8">
              This product was created with data that were supplied by and are proprietary to Equibase Company LLC. All rights reserved.
              <br />

              Data provided or compiled by Equibase Company LLC generally are accurate but errors and omissions occur as a result of incorrect data received from others, mistakes in processing and other causes. Horse Racing Labs, LLC and Equibase Company LLC disclaim responsibility for the consequences, if any, of such errors, but would appreciate having any such errors called to their attention.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
